export const BUTTON_NAMES = {
  ADD_PAYMENT_CARD: 'add payment card',
  FOOTER_BUTTON: 'footer button',
  PLACE_NEW_ORDER: 'place new order',
  GOT_IT: 'got it',
  CONTINUE: 'continue',
  DONE: 'done',
  NEXT: 'next',
  GET_STARTED: 'get started',
  SUBMIT: 'submit',
  SELECT_ADDRESS: 'select address',
  CONFIRM_LOCATION: 'confirm location',
  PROMO_APPLY: 'promo apply',
  SAVE_ADDRESS: 'save address',
  APPLY: 'apply',
  SERVICE_ADD: 'service add',
  VIEW_PRICING: 'view pricing',
  GO_BACK: 'go back',
  CLEAR_ALL: 'clear all',
  CLEAR_BASKET: 'clear basket',
  SUPPORT_CALL: 'support call',
  SUPPORT_CHAT: 'support chat',
  SUPPORT_EMAIL: 'support email',
  FAQ: 'faq',
  SAVE: 'save',
  PROCEED: 'proceed',
  PAYMENT_OPTION: 'payment options',
  SUBMIT_CANCEL_ORDER: 'submit cancel order',
  ADD: 'add',
  REMOVE: 'remove',
  CONTINUE_ORDER: 'continue order',
};
